import {combine, createEffect, createStore} from 'effector';
import {createGate} from 'effector-react';

import {Factory} from 'types/profile';

export const FactoryDetailsGate = createGate<{id: string}>();

export const loadFactoryFx = createEffect<{id: string}, Factory>();

export const factory$ = createStore<Factory | null>(null);

export const factoryDetailsState$ = combine({
    factory: factory$,
    factoryPending: loadFactoryFx.pending,
});
